import { Modal } from 'react-bootstrap'
import ReactPlayer from 'react-player/wistia'
import Cookies from 'universal-cookie';

const ModalWhatVitAndMinDo = (props) => {

    const reload =() => window.location.reload();

    const onEnded = function () {
        
        const minutes = 120;

        var d = new Date();
        d.setTime(d.getTime() + (minutes*60*1000));
        const expires = "expires="+ d.toUTCString();

        const cookies = new Cookies();
        cookies.set('video2', 'done', { path: '/' }, expires);
        console.log('video ended')
    }

    return(
        <>
        <Modal {...props} size="xl" aria-labelledby="modal" className="modal-discover-videos" onExit={reload}>
            <Modal.Header closeButton>
                <Modal.Title><strong>What Do Vitamins And Minerals Do?</strong></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="player-wrapper">
                    <ReactPlayer controls={true} playing={true} 
                    url="https://home.wistia.com/medias/onao2bu025" 
                    width="100%" height="100%" 
                    className="react-player" 
                    onEnded={onEnded}
                    />  
                </div>
            </Modal.Body>
        </Modal>
        </>
    )
};

export default ModalWhatVitAndMinDo;